var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12309_233441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.461548 2.29047C0.461548 1.32751 1.24218 0.546875 2.20514 0.546875H23.1282C24.0912 0.546875 24.8718 1.32751 24.8718 2.29046V30.5126C24.8718 31.8855 23.3585 32.7199 22.1975 31.987L13.5974 26.5583C13.0288 26.1994 12.3045 26.1994 11.736 26.5583L3.13583 31.987C1.97481 32.7199 0.461548 31.8855 0.461548 30.5126V2.29047Z",
    fill: "url(#paint0_linear_12309_233441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9133 4.45549C12.2496 3.87813 13.0837 3.87813 13.4199 4.45549L15.8553 8.63672C15.9785 8.84822 16.1849 8.99819 16.4241 9.04999L21.1533 10.0741C21.8063 10.2155 22.064 11.0088 21.6188 11.507L18.3948 15.1152C18.2317 15.2977 18.1529 15.5404 18.1775 15.7839L18.665 20.598C18.7323 21.2628 18.0575 21.7531 17.4461 21.4836L13.0182 19.5324C12.7942 19.4337 12.539 19.4337 12.3151 19.5324L7.88717 21.4836C7.27574 21.7531 6.60095 21.2628 6.66826 20.598L7.15568 15.7839C7.18034 15.5404 7.10149 15.2977 6.93841 15.1152L3.71439 11.507C3.26921 11.0088 3.52696 10.2155 4.17998 10.0741L8.90912 9.04999C9.14834 8.99819 9.35476 8.84822 9.47794 8.63672L11.9133 4.45549Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12309_233441",
    x: 0.461548,
    y: 0.546875,
    width: 31.3846,
    height: 38.6872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.48718,
    dy: 3.48718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74359
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12309_233441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12309_233441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12309_233441",
    x1: 12.6667,
    y1: 0.546875,
    x2: 12.6667,
    y2: 33.6751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08C3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.2c8aeb4ea7db6b4d18336ad503d34040.svg";
export { ForwardRef as ReactComponent };